import Api from "./Api";

const endpoint = "/widgets";
export default {
    get() {
        return Api.fetchData(endpoint);
    },
    getCollection() {
        return Api.fetchData(endpoint + "/collection");
    },
    getWidgetData(url) {
        return Api.fetchData(url);
    },
    addWidget(id, rank) {
        return Api.putData(endpoint, {
            id: id,
            rank: rank
        });
    },
    removeWidget(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
